'use client'

import dynamic from 'next/dynamic'
import type {SectionFormEmbed} from '@/types/sanity'
import type {SiteLite} from '@/multisite/types'
import {resolveWidgetMarket} from '@/components/layout/dealerWidgetBrands'

// Dynamically import the 1000+ line client component so it doesn't ship
// in the eager bundle for every page that goes through [...slug] (most of
// which never render a form). Lighthouse flagged the eagerly-bundled
// version as ~80KB shipped, ~84% unused per page on prototype routes.
const FormEmbedSectionClient = dynamic(
  () =>
    import('@/components/sections/FormEmbedSectionClient').then(
      (mod) => mod.FormEmbedSectionClient,
    ),
  {ssr: false},
)

export function FormEmbedSection({section, site}: {section: SectionFormEmbed; site?: SiteLite}) {
  if (!section.formName) return null

  return (
    <FormEmbedSectionClient
      formName={section.formName}
      language={section.language || 'en'}
      market={resolveWidgetMarket(site)}
    />
  )
}
